import { type FC } from 'react'
import { usePagination } from 'react-instantsearch'
import { useIntl } from 'react-intl'

import { productSearchPaginationBuildPaginationItems } from './productSearchPaginationBuildPaginationItems'
import {
  type PaginationItem,
  ProductSearchPaginationItem,
} from './ProductSearchPaginationItem'

type ProductSearchPaginationProps = {
  onRefine?: (pageNumber: number) => void
}

export const ProductSearchPagination: FC<ProductSearchPaginationProps> = ({
  onRefine,
}) => {
  const intl = useIntl()
  const pagination = usePagination()

  if (pagination.nbPages <= 1) {
    return null
  }

  const paginationItems =
    productSearchPaginationBuildPaginationItems(pagination)

  return (
    <nav
      aria-label={intl.formatMessage({ id: 'general.label.pagination' })}
      className="mt-4 flex w-full justify-end"
      data-qa-id="pagination-links"
    >
      <ul className="my-4 flex list-none items-center">
        {paginationItems.map((paginationItem: PaginationItem) => (
          <li key={paginationItem.pageNumber + paginationItem.renderType}>
            <ProductSearchPaginationItem
              paginationItem={paginationItem}
              refine={() => {
                onRefine?.(paginationItem.pageNumber)
                pagination.refine(paginationItem.pageNumber)
              }}
            />
          </li>
        ))}
      </ul>
    </nav>
  )
}
